import { usePublicOrderWithItems } from "@babackapp/private-api-client/client/use-search-public-order";
import { useParams } from "react-router-dom";
import type { Order } from "../types";

export function usePublicOrder(orderId: string) {
  // The URL `:shopId` param is the Shopify providerId (see useWidgetParams).
  const { shopId } = useParams<{ shopId: string }>();
  return usePublicOrderWithItems<Order>(orderId, {
    select: (data) => data as Order,
    providerId: shopId,
  });
}
